import './styles/main.scss';
import { App } from './ui/App';
import { registerSW } from 'virtual:pwa-register';

// PWA 서비스 워커 등록
registerSW({ immediate: true });

const root = document.getElementById('app');
if (!root) throw new Error('#app not found');

new App(root);
